// Euclidean distance transform (Felzenszwalb & Huttenlocher): round contours, where a flood fill gives diamonds
const INF = 1e20;

function transform1d(f, n, d, v, z) {
    let k = 0;
    v[0] = 0;
    z[0] = -INF;
    z[1] = INF;
    for (let q = 1; q < n; q++) {
        let s = (f[q] + q * q - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
        while (s <= z[k]) {
            k--;
            s = (f[q] + q * q - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
        }
        k++;
        v[k] = q;
        z[k] = s;
        z[k + 1] = INF;
    }
    k = 0;
    for (let q = 0; q < n; q++) {
        while (z[k + 1] < q) k++;
        d[q] = (q - v[k]) * (q - v[k]) + f[v[k]];
    }
}

// squared px distance from every pixel to the nearest set pixel, >= INF when none is set
function squaredDistanceTo(target, width, height) {
    const grid = new Float64Array(width * height);
    for (let i = 0; i < grid.length; i++) grid[i] = target[i] ? 0 : INF;
    const n = Math.max(width, height);
    const f = new Float64Array(n);
    const d = new Float64Array(n);
    const v = new Int32Array(n);
    const z = new Float64Array(n + 1);
    for (let x = 0; x < width; x++) {
        for (let y = 0; y < height; y++) f[y] = grid[y * width + x];
        transform1d(f, height, d, v, z);
        for (let y = 0; y < height; y++) grid[y * width + x] = d[y];
    }
    for (let y = 0; y < height; y++) {
        const row = y * width;
        // rows stay contiguous, so they are transformed in place
        transform1d(grid.subarray(row, row + width), width, d, v, z);
        grid.set(d.subarray(0, width), row);
    }
    return grid;
}

// px distance from every pixel to the nearest set pixel; Infinity when none is set
function distanceTo(target, width, height) {
    const grid = squaredDistanceTo(target, width, height);
    const out = new Float32Array(grid.length);
    for (let i = 0; i < out.length; i++) out[i] = grid[i] >= INF / 2 ? Infinity : Math.sqrt(grid[i]);
    return out;
}

// round (disc) max/min filter of radius r over 0/1 bits; off-board pixels count as neither
function morph(bits, width, height, radius, dilate) {
    const limit = radius * radius;
    const out = new Uint8Array(bits.length);
    if (dilate) {
        const grid = squaredDistanceTo(bits, width, height);
        for (let i = 0; i < out.length; i++) out[i] = grid[i] <= limit ? 1 : 0;
        return out;
    }
    const gaps = new Uint8Array(bits.length);
    for (let i = 0; i < gaps.length; i++) gaps[i] = bits[i] ? 0 : 1;
    const grid = squaredDistanceTo(gaps, width, height);
    for (let i = 0; i < out.length; i++) out[i] = grid[i] > limit ? 1 : 0;
    return out;
}

// box blur run twice (close to a tent), smooths the creases a distance field has along its ridges
function blurField(field, width, height, radius) {
    const pass = (src, horizontal) => {
        const dst = new Float32Array(src.length);
        const lines = horizontal ? height : width;
        const length = horizontal ? width : height;
        const stride = horizontal ? 1 : width;
        for (let line = 0; line < lines; line++) {
            const start = horizontal ? line * width : line;
            let sum = 0;
            let count = 0;
            for (let k = 0; k < Math.min(radius, length); k++, count++) sum += src[start + k * stride];
            for (let k = 0; k < length; k++) {
                if (k + radius < length) {
                    sum += src[start + (k + radius) * stride];
                    count++;
                }
                if (k - radius > 0) {
                    sum -= src[start + (k - radius - 1) * stride];
                    count--;
                }
                dst[start + k * stride] = sum / count;
            }
        }
        return dst;
    };
    let out = field;
    for (let i = 0; i < 2; i++) out = pass(pass(out, true), false);
    return out;
}

module.exports = { distanceTo, morph, blurField };
